import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { FixedState } from '../types'

const getActiveSectionId: Getter<FixedState, RootState> = ({
  activeSectionId,
}) => activeSectionId

export default getActiveSectionId
